import script from "./InterPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./InterPhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./InterPhoneInput.vue?vue&type=style&index=0&id=a25800b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a25800b2"]])

export default __exports__